import { AxiosRequestConfig } from 'axios';
import { getBrandDetailsFromBrandJson } from './share';
import apiRequest from '../api/apiRequest';
import { REGEX } from '../constants/regex';
/**
 * wrapper only for real time email validation via api
 */
export async function isValidEmailApiWrapper(email: string, signal: AbortSignal): Promise<boolean> {
    try {
        const request: AxiosRequestConfig = {
            url: process.env.EMAIL_VALIDATION_API as string,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'apikey': process.env.VALIDATE_KEY
            },
            signal,
            data: { email },
            method: 'POST'
        }
        const res = await apiRequest<boolean>(request)
        return res;
    }
    catch (err) {
        const error = new Error("Send grid API falied" + err)
        throw error
    }
}


type ValidEmailReturnTypes =
    | 'EmptyField'
    | 'RegexFailed'
    | 'SendGridResponseFalse'
    | 'SendGridFailed'
    | 'EmailValidationPassed'
type ValidateEmailParams = {
    value: string;
    signal: AbortSignal;
    conceptCode: string;
    historyCount?: number;
}
type EmailHistoryObject = {
    value: string;
    validity: ValidEmailReturnTypes;
}

/**
 * Regex, empty and real time validation for email controlled by brandjson
 */
export async function validateEmail(params: ValidateEmailParams): Promise<ValidEmailReturnTypes> {
    const { value, conceptCode, signal, historyCount = 5 } = params;
    const persistentStorageKey = 'emailValidationHistory'
    const persistentStorage = sessionStorage
    const persistentStorageCache = persistentStorage.getItem(persistentStorageKey)
    let memoedValue: EmailHistoryObject
    let emailHistory: EmailHistoryObject[] = []
    let validatedCase: ValidEmailReturnTypes = 'EmailValidationPassed'
    const updateHistory = () => {
        memoedValue = {
            value,
            validity: validatedCase
        }
        if (emailHistory.length > historyCount) {
            emailHistory.shift()
        }
        emailHistory.push(memoedValue)
        persistentStorage.setItem(persistentStorageKey, JSON.stringify(emailHistory))
    }
    if (value.trim() === '') {
        validatedCase = 'EmptyField'
        return validatedCase
    }
    const emailRegex = REGEX.sendEmail;
    if (!emailRegex.test(value)) {
        validatedCase = 'RegexFailed'
        return validatedCase
    }
    if (persistentStorageCache) {
        emailHistory = JSON.parse(persistentStorageCache) as EmailHistoryObject[]
        memoedValue = emailHistory.find((emailObject) => emailObject.value === value) as EmailHistoryObject
        if (memoedValue) {
            validatedCase = memoedValue.validity
            return validatedCase
        }
    }
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);
    if (!brandData['enable_realtime_email_validation']) {
        return validatedCase
    };
    try {
        const response = await isValidEmailApiWrapper(value, signal)
        if (!response) {
            validatedCase = 'SendGridResponseFalse'
            updateHistory();
            return validatedCase;
        } else {
            persistentStorage.removeItem(persistentStorageKey)
        }
    } catch (error) {
        console.warn(error)
        validatedCase = 'SendGridFailed'
        return validatedCase;
    }
    updateHistory();
    return validatedCase;
}

window.ValidateEmail = validateEmail